module.exports = __webpack_public_path__ + "img/icon-youtube.852036da.svg";